module.exports = __webpack_public_path__ + "img/lifecoach5.ed45279e.jpg";